import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import type { CatalogRecord } from '@okmaps/shared';
import ResultRow from './ResultRow.js';

interface Props {
  readonly records: readonly CatalogRecord[];
}

/** Flat results, used when a search or a category has narrowed the catalog. */
export default function ResultList({ records }: Props) {
  if (records.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          Nothing matched.
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Try a broader term, or clear the filters above.
        </Typography>
      </Box>
    );
  }

  return (
    <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0 }}>
      {records.map((record, i) => (
        <Box component="li" key={record.id}>
          {i > 0 && <Divider component="div" />}
          <ResultRow record={record} />
        </Box>
      ))}
    </Box>
  );
}
